export class ModalConfig {
    width: string;
}
